import { render } from "./MethodAssessmentPage.vue?vue&type=template&id=37d19ba5"
import script from "./MethodAssessmentPage.vue?vue&type=script&lang=js"
export * from "./MethodAssessmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__